import { Outlet } from "react-router-dom"
import { Box } from '@mui/material';


const Layout = () => {
    return (
      <Box
        component="main"
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: '#f0f2f5', // Adjust to your background color
        }}>
        <Outlet />
      </Box>
    );
}

export default Layout
